import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../Avatar';

const AssetIcon = ({ visualizationType }) => (
    <Avatar src={`/assets/${visualizationType}.svg`} alt="visualization" />
);

AssetIcon.propTypes = {
    visualizationType: PropTypes.string.isRequired,
};

export default AssetIcon;



// WEBPACK FOOTER //
// ./src/components/assets/AssetIcon.js